import { Box } from "@mui/material";
import SideBarList from "./sidebarList";

export default function SideBar(){
    return(
        <Box flex={1}>
            <SideBarList></SideBarList>
        </Box>
    )
}